import React, { FC } from 'react';
import SkapaInlineMessage from '@ingka/inline-message';
import InformationCircleIconPaths from '@ingka/ssr-icon/paths/information-circle';
import { WriteDirection } from 'sofa-reborn-react';

type Props = {
	writeDirection: WriteDirection;
	title: string;
	text: string;
};

const CoverDisclaimer: FC<Props> = (props) => {
	const backButtonWidth = document.getElementById('backButton')?.getBoundingClientRect().width;
	const margin = backButtonWidth && props.title.length === 0 ? backButtonWidth + 16 : 0;
	return (
		<SkapaInlineMessage
			title={props.title}
			body={props.text}
			ssrIcon={InformationCircleIconPaths}
			variant={'informative'}
			subtle={margin > 0}
			style={{
				marginLeft: props.writeDirection === 'ltr' ? margin + 'px' : 0,
				marginRight: props.writeDirection === 'rtl' ? margin + 'px' : 0,
			}}
		/>
	);
};
export default CoverDisclaimer;
